import { cn } from "@/lib/utils";

interface SpinnerProps {
  /** Outer diameter in px. Border + inset scale proportionally. */
  size?: number;
  className?: string;
  "aria-label"?: string;
}

/**
 * Brand dual-ring loader (teal outer, orange inner counter-rotating).
 * Styled via `.brand-loader` in index.css.
 */
export const Spinner = ({ size = 48, className, ...rest }: SpinnerProps) => {
  const border = Math.max(2, Math.round(size * (5 / 48)));
  const inset = Math.max(3, Math.round(size * (6 / 48)));
  return (
    <span
      role="status"
      aria-label={rest["aria-label"] ?? "Loading"}
      className={cn("brand-loader", className)}
      style={
        {
          "--brand-loader-size": `${size}px`,
          "--brand-loader-border": `${border}px`,
          "--brand-loader-inset": `${inset}px`,
        } as React.CSSProperties
      }
    />
  );
};

export default Spinner;
